import { useTranslation } from 'react-i18next';
import { classNames } from '@utils/classNames';

type NotDetectableProps = {
  className?: string;
  rawValue?: string;
};

export const NotDetectable = ({ className, rawValue }: NotDetectableProps) => {
  const { t } = useTranslation('component', { keyPrefix: 'parameterList' });
  return (
    <span
      className={classNames('text-dark text-sm font-extrabold', className)}
      data-testid="not-detectable"
    >
      {rawValue ? rawValue : t('notDetectable')}
    </span>
  );
};
